import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useZones } from '../hooks/useZones';
import ZoneRecords from '../components/ZoneRecords';

const ZoneRecordsPage = ({ onZoneChange }) => {
    const { zoneId } = useParams();
    const navigate = useNavigate();
    const { zones, loading } = useZones();
    const [selectedZone, setSelectedZone] = useState(null);

    useEffect(() => {
        if (!loading && zones.length > 0 && zoneId) {
            const zone = zones.find(z => z.id === zoneId);
            if (zone) {
                setSelectedZone(zone);
                // Update breadcrumb with zone name
                if (onZoneChange) {
                    onZoneChange(zone.name);
                }
            } else {
                // Zone not found, redirect to zones list
                navigate('/zones');
            }
        }
    }, [zones, loading, zoneId, navigate, onZoneChange]);

    if (loading) {
        return (
            <div className="loading">
                <div className="spinner"></div>
                <span>Carregando zona...</span>
            </div>
        );
    }

    if (!selectedZone) {
        return (
            <div className="loading">
                <div className="spinner"></div>
                <span>Carregando zona...</span>
            </div>
        );
    }

    return (
        <ZoneRecords
            zone={selectedZone}
            onBack={() => navigate('/zones')}
        />
    );
};

export default ZoneRecordsPage;
